import React from 'react'

const polar = (cx, cy, r, angleDeg) => {
  const a = (angleDeg - 180) * (Math.PI / 180)
  return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) }
}

const arcPath = (cx, cy, r, startDeg, endDeg) => {
  const start = polar(cx, cy, r, startDeg)
  const end = polar(cx, cy, r, endDeg)
  const large = endDeg - startDeg > 180 ? 1 : 0
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${large} 1 ${end.x} ${end.y}`
}

export default function Gauge({ value = 0, color = '#34d399', label, caption }) {
  const ratio = Math.max(0, Math.min(1, value))
  const cx = 90
  const cy = 90
  const r = 72
  const endAngle = ratio * 180

  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 180 108" className="w-full max-w-[220px]">
        <path d={arcPath(cx, cy, r, 0, 180)} fill="none" stroke="var(--onds-border)" strokeWidth="12" strokeLinecap="round" />
        {ratio > 0 && (
          <path
            d={arcPath(cx, cy, r, 0, endAngle)}
            fill="none"
            stroke={color}
            strokeWidth="12"
            strokeLinecap="round"
            style={{ transition: 'all 0.8s ease' }}
          />
        )}
        <text x="90" y="82" textAnchor="middle" fontSize="26" fontWeight="700" fill="var(--onds-text)">
          {label}
        </text>
      </svg>
      {caption && (
        <span className="text-[11px] text-[var(--onds-text-dim)] -mt-1 text-center">{caption}</span>
      )}
    </div>
  )
}
